const apiAbortController = (() => {
  let controller = new AbortController();
  let controllerSignal = controller.signal;

  const abortPendingRequest = () => {
    controller.abort();
    controller = new AbortController();
    controllerSignal = controller.signal;
  };

  const getSignalToken = () => controllerSignal;

  return {
    abortPendingRequest,
    getSignalToken,
  };
})();

export default apiAbortController;
